import React from 'react'
import { Modal } from 'react-bootstrap'
import { MedicineDosesUnitOptions, MedicineTypeOptions, MedicineReactionOptions } from '../../../../Context/constants'
import { Errors } from '../../../../Component/Error'
import useMuiCompontent from '../../../../Hooks/useMuiCompontent'
import { SelectBox } from '../../../../Component/Inputs'

const AddMedicine = ({ data, methods }) => {
    const {
        openModal,
    } = data

    const {
        handleClosedModal,
        handleAddMedicine,
        handleOpenModal
    } = methods
    const { CustomButton } = useMuiCompontent()
    console.log(handleAddMedicine?.values?.medicineType, "handleAddMedicine?.values?.medicineType")
    return (
        <Modal size='lg' show={openModal?.addMedicine} centered>
            <Modal.Body>
                <div >
                    <p className="modal-title mb-0"> {`${(openModal?.data?.clone) ? "Clone" : openModal?.data ? "Update" : "Add"} Medicine`} </p>
                </div>
                <div className="modal-body  cus-i">
                    <div className="row">
                        <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="row">
                                        <div className="col-lg-5 px-0">
                                            <label className="form-label mb-0">Name<span className='Star_Mark'>*</span></label>
                                        </div>
                                        <div className="col-lg-7">
                                            <input maxLength={100} type="text" name='name' className="form-control" id="exampleInputEmail1"
                                                value={handleAddMedicine?.values.name} onChange={(e) => handleAddMedicine.setFieldValue("name", e.target.value)} aria-describedby="emailHelp"
                                                onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                            />
                                            <Errors formikfun={handleAddMedicine} name={"name"} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="row">
                                        <div className="col-lg-5 px-0">
                                            <label className="form-label mb-0">Abbreviation<span className='Star_Mark'>*</span></label>
                                        </div>
                                        <div className="col-lg-7">
                                            <input maxLength={50} type="text" name='abbr' className="form-control" id="exampleInputEmail1"
                                                value={handleAddMedicine?.values.abbr} onChange={(e) => handleAddMedicine.setFieldValue("abbr", e.target.value)} aria-describedby="emailHelp"
                                                onInput={(e) => { if (e.target.value.length > 50) e.target.value = e.target.value.slice(0, 50); }}
                                            />
                                            <Errors formikfun={handleAddMedicine} name={"abbr"} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="row">
                                        <div className="col-lg-5 px-0">
                                            <label className="form-label mb-0">Brand Name<span className='Star_Mark'>*</span></label>
                                        </div>
                                        <div className="col-lg-7">
                                            <input maxLength={50} type="text" name='brandName' className="form-control" id="exampleInputEmail1"
                                                value={handleAddMedicine?.values.brandName} onChange={(e) => handleAddMedicine.setFieldValue("brandName", e.target.value)} aria-describedby="emailHelp"
                                                onInput={(e) => { if (e.target.value.length > 50) e.target.value = e.target.value.slice(0, 50); }}
                                            />
                                            <Errors formikfun={handleAddMedicine} name={"brandName"} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="row">
                                        <div className="col-lg-5 px-0">
                                            <label className="form-label mb-0">Medicine Type<span className='Star_Mark'>*</span></label>
                                        </div>
                                        <div className="col-lg-7">
                                            <SelectBox
                                                placeholder="Select Medicine Type"
                                                value={handleAddMedicine?.values?.medicineType}
                                                name="medicineType"
                                                keys="value"
                                                label="label"
                                                menuValeu="value"
                                                handleChange={(e) => {
                                                    handleAddMedicine?.setFieldValue("medicineType", e.target.value)
                                                    handleAddMedicine?.setFieldValue("unit", "")
                                                }}
                                                option={MedicineTypeOptions}
                                            />
                                            <Errors formikfun={handleAddMedicine} name={"medicineType"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="row">
                                        <div className="col-lg-5 px-0">
                                            <label className="form-label mb-0">Strength (dose & unit )<span className='Star_Mark'>*</span></label>
                                        </div>
                                        <div className="col-lg-7">
                                            <div className='d-flex' style={{ gap: '10px' }}>
                                                <input maxLength={50} type="text" name='dose' className="form-control" id="exampleInputEmail1"
                                                    value={handleAddMedicine?.values.dose} onChange={(e) => handleAddMedicine.setFieldValue("dose", e.target.value)} aria-describedby="emailHelp"
                                                    onInput={(e) => { if (e.target.value.length > 50) e.target.value = e.target.value.slice(0, 50); }}
                                                />
                                                <SelectBox
                                                    placeholder="Select unit"
                                                    value={handleAddMedicine?.values?.unit}
                                                    name="unit"
                                                    keys="value"
                                                    label="label"
                                                    menuValeu="value"
                                                    handleChange={(e) => handleAddMedicine?.setFieldValue("unit", e.target.value)}
                                                    option={MedicineDosesUnitOptions?.filter((item) => {
                                                        const medicineType = MedicineTypeOptions?.find(
                                                            (cur) => cur.value === handleAddMedicine?.values?.medicineType
                                                        );
                                                        return medicineType ? item.value === medicineType.unit : true;
                                                    })}
                                                />
                                            </div>
                                            <Errors formikfun={handleAddMedicine} name={"dose"} extraName={"unit"} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="row">
                                        <div className="col-lg-5 px-0">
                                            <label className="form-label mb-0">Reaction</label>
                                        </div>
                                        <div className="col-lg-7">
                                            <SelectBox
                                                placeholder="Select reaction"
                                                value={handleAddMedicine?.values?.reaction}
                                                name="reaction"
                                                keys="value"
                                                label="label"
                                                menuValeu="value"
                                                handleChange={(e) => handleAddMedicine?.setFieldValue("reaction", e.target.value)}
                                                option={MedicineReactionOptions}
                                            />
                                            <Errors formikfun={handleAddMedicine} name={"reaction"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-end mt-3 pe-1">
                    <CustomButton variant="outlined" className='mui_button_color me-2' onClick={() => { handleClosedModal("addMedicine"); handleOpenModal("add", openModal?.previoursData); handleAddMedicine.resetForm() }}>Cancel</CustomButton>
                    <CustomButton variant="contained" className='mui_button_color' onClick={handleAddMedicine.handleSubmit}>{(openModal?.data?.clone || !openModal?.data) ? "Save" : "Update"}</CustomButton>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddMedicine
